<template>
  <GwMenu
    class="tratblcntrls_menu"
    :flOptions="{ offset: 0 }"
    placement="right-start"
  >
    <template #opener>
      <div class="csst clr-grey mdi mdi-dots-vertical tratblcntrls_opener icon_btn">
        <div
          class="csst_content text-nowrap clr-white"
          style="left: 100%; transform: translate(0.25rem, 0)"
          v-html="$t('tooltips.table_controls_menu')"
        ></div>
      </div>
    </template>
    <template #default="{ methods }">
      <GwBtns
        :options="[
          {
            fn: newSession,
            icon: 'mdi-fast-forward',
            text: $t('hotkeys.practice_next_hand_key', {
              key: hotkeys.practice_play_new_hand.displayCombination,
            }),
          },
          {
            fn: repeatSession,
            icon: 'mdi-reload',
            text: $t('hotkeys.practice_replay_hand_key', {
              key: hotkeys.practice_replay_hand.displayCombination,
            }),
          },
        ]"
        class="gwbtns_vertical_white gw_menu"
        @click="
          (_e, item) => {
            methods.toggleOpen(false)
            item.fn()
          }
        "
      >
        <template #default="{ item }">
          <i
            class="mdi text-normal mr-2"
            :class="item.icon"
          ></i>
          <div v-html="item.text"></div>
        </template>
        <template #after>
          <div>
            <router-link
              target="_blank"
              class="gw_btn clr-white"
              style="--clr-back: var(--gwbtn-clr-back)"
              :to="
                links_getLink({
                  pathName: 'StudySolutions',
                  hasTmpBoard: true,
                  asRouterLink: true,
                  namespace,
                  customQuery: { soltab: 'strategy' },
                })
              "
            >
              <i class="mdi mdi-school text-normal mr-2"></i>
              <!-- <div
                class="mr-auto text-medium"
                v-html="$t('tooltips.study_spot')"
              ></div> -->
              <div
                class="mr-auto text-medium"
                v-html="
                  $t('hotkeys.practice_study_spot_key', {
                    key: hotkeys.practice_study_spot.displayCombination,
                  })
                "
              ></div>
            </router-link>
          </div>
        </template>
      </GwBtns>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import { throttle } from 'lodash'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerControls',
  mixins: [float_mix, links_mix],
  props: {
    namespace: { String, required: true },
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    newSession: throttle(function () {
      if (!this.loadingSetup && !this.loadingSession && !this.sessionFinished) {
        this.$store.dispatch(`${this.namespace}/trainer_new_hand`)
      }
    }, 1000),
    repeatSession: throttle(function () {
      if (!this.loadingSetup && !this.loadingSession && !this.sessionFinished) {
        this.$store.dispatch(`${this.namespace}/trainer_repeat_hand`)
      }
    }, 1000),
  },
  computed: {
    sessionFinished() {
      return this.$store.getters.session_finished
    },
    loadingSetup() {
      return this.$store.getters.api_get('api_practice_setup', this.activeNamespace)?.loading
    },
    loadingSession() {
      return this.$store.getters.api_get('api_practice_session', this.activeNamespace)?.loading
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
  },
  components: {
    GwMenu,
    GwBtns,
  },
}
</script>
<style lang="scss" scoped>
.tratblcntrls {
  &_opener {
    text-shadow: var(--text-shadow_outlined);
    font-size: 1.25rem;
    height: 2rem;
    width: 2rem;
  }
  // font-size: 1rem;
  // display: flex;
  // flex-direction: column;
  // max-height: var(--vh-3);
  // background: var(--clr-black-1);
  // padding: 0.5rem 0;
}
</style>
